/**
 * Baseball market outcome name constants (replaces caribe7/lib/constants/baseball-markets).
 */

export const FINAL_OUTCOME_NAMES = [
  'STRIKEOUT',
  'WALK',
  'FLYOUT',
  'GROUNDOUT',
  'HIT',
  'HOMERUN',
  'HITBYPITCH',
] as const;
